import React from 'react';
import LessonRow from './LessonRow';


function LessonTable({
    lessons = [],
    onDelete,
    onEdit,
    }) {
    return (
           
        <table id="lessons">
            <caption className='caption_text'>
                Lessons Table 
                </caption>  

            <thead>
                <tr>
                    <th className='type_box'>Description of Lesson</th>
                    <th className='link_box'>Lesson</th>
                    <th className='link_box'>Image</th>
                    <th style={{fontSize: '12px'}}>Delete</th>
                    <th style={{fontSize: '12px'}}>Edit</th>
                </tr>
            </thead>

            <tbody>
                {lessons.map((lesson, i) => ( 
                <LessonRow 
                    lesson={lesson} 
                    key={i} 
                    onDelete={onDelete}
                    onEdit={onEdit}
                    />
                ))}
            </tbody>
        </table>
    );
}
export default LessonTable;
